import React from "react";
import { SettingsOptionContainer } from "../../styles";

import Manual from "./enrichment/Manual";

function ContentSettings() {
  return (
    <>
      <SettingsOptionContainer>
        <Manual />
      </SettingsOptionContainer>
    </>
  );
}

export default ContentSettings;
